// ⚡🧪 THE POG'CAPACITOR — community charge meter (lore made real)
import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const PogCapacitor = () => {
  const [cap, setCap] = useState(null);
  const [msg, setMsg] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    axios.get(`${API}/capacitor`, { withCredentials: true }).then((r) => setCap(r.data)).catch(() => {});
  }, []);

  if (!cap) return null;
  const pct = Math.min(100, (cap.charge / cap.goal) * 100);

  const feed = async () => {
    setBusy(true);
    try {
      const r = await axios.post(`${API}/capacitor/feed`, {}, { withCredentials: true });
      setCap((c) => ({ ...c, charge: r.data.charge, striking: r.data.striking }));
      if (r.data.struck) setMsg("⚡ 9,000 POGAWATTS — GOLDEN LIGHTNING STRIKES THE MAP!");
      else if (r.data.capped) setMsg("🔋 You've fed the core all you can today — return tomorrow!");
    } catch (e) { /* ignore */ }
    setBusy(false);
  };

  const claim = async () => {
    setBusy(true);
    try {
      const r = await axios.post(`${API}/capacitor/claim`, {}, { withCredentials: true });
      if (r.data.ok) { setMsg(`⚡ +${r.data.bonus} POG BUCKS from the lightning!`); setCap((c) => ({ ...c, claimed: true })); }
      else setMsg(r.data.reason || "");
    } catch (e) { setMsg("Sign in to catch the lightning ⚡"); }
    setBusy(false);
  };

  return (
    <div data-testid="pog-capacitor" className={`rounded-2xl border p-3.5 ${cap.striking ? "border-yellow-300 bg-yellow-400/10 shadow-[0_0_20px_rgba(250,204,21,0.35)]" : "border-fuchsia-400/40 bg-fuchsia-500/5"}`}>
      <div className="flex items-center justify-between">
        <p className="text-[11px] font-heading font-black text-fuchsia-300">⚡🧪 THE POG'CAPACITOR</p>
        <p className="text-[10px] font-black text-slate-400">{cap.strikes} strike{cap.strikes === 1 ? "" : "s"} all-time</p>
      </div>
      <p className="mt-1 text-[10px] font-bold text-slate-400">Every POG'R feeds the core. At 9,000 POGAWATTS — golden lightning hits the whole map. 🐲</p>
      <div className="mt-2 h-3 rounded-full bg-slate-800 overflow-hidden border border-slate-700">
        <div className={`h-full rounded-full transition-[width] duration-500 ${cap.striking ? "bg-yellow-400 animate-pulse" : "bg-gradient-to-r from-fuchsia-500 to-yellow-400"}`} style={{ width: `${Math.max(2, pct)}%` }} />
      </div>
      <div className="mt-1 flex items-center justify-between">
        <p className="text-[10px] font-black text-fuchsia-200">{cap.charge.toLocaleString()} / {cap.goal.toLocaleString()} POGAWATTS</p>
        {cap.striking && !cap.claimed ? (
          <button data-testid="capacitor-claim-btn" onClick={claim} disabled={busy}
            className="px-3 h-7 rounded-full bg-yellow-400 text-slate-900 text-[10px] font-heading font-black animate-pulse disabled:opacity-50">
            ⚡ CATCH THE LIGHTNING +25
          </button>
        ) : (
          <button data-testid="capacitor-feed-btn" onClick={feed} disabled={busy}
            className="px-3 h-7 rounded-full bg-fuchsia-500/20 border border-fuchsia-400/50 text-fuchsia-200 text-[10px] font-heading font-black active:scale-95 disabled:opacity-50">
            🔌 FEED THE CORE
          </button>
        )}
      </div>
      {msg && <p data-testid="capacitor-msg" className="mt-1.5 text-[10px] font-black text-yellow-300">{msg}</p>}
    </div>
  );
};
